import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import { constants } from '../../../../../shared/enums/constants';
import { getFormattedTasksCount, getSelectedTasksCount } from '../utils/helper';

type IProps = {
  selectedTasks: any[];
  bulkSelectedTasks: any;
  totalTasks: number;
  handleSelectAllTasks: VoidFunction;
  handleClearSelection: VoidFunction;
  currentFilters?: any;
  currentTasks?: any[];
};

const TasksSelectedRowInfoBanner: React.FC<IProps> = ({
  selectedTasks,
  bulkSelectedTasks,
  totalTasks,
  handleSelectAllTasks,
  handleClearSelection,
  currentFilters,
  currentTasks,
}) => {
  const { t } = useTranslation();

  const selectedTasksCount = getSelectedTasksCount(
    selectedTasks,
    bulkSelectedTasks,
    totalTasks,
    currentFilters,
    currentTasks,
  );

  useEffect(() => {
    if (selectedTasksCount === 0) {
      handleClearSelection();
    }
  }, [selectedTasksCount]);

  const divClasses = classnames([
    'email-selected-row-info',
    {
      'email-selected-row-info-waring':
        selectedTasks.length > 0 || bulkSelectedTasks?.isAllTasksSelected,
    },
  ]);

  const spanClasses = classnames([
    'semibold-1',
    {
      'popover-arrow-color-txt':
        selectedTasks.length > 0 || bulkSelectedTasks?.isAllTasksSelected,
    },
    {
      'red-txt-12':
        selectedTasks.length === 0 && !bulkSelectedTasks?.isAllTasksSelected,
    },
  ]);

  const renderSelectedTasksDetails = () => (
    <div className="d-flex">
      {selectedTasksCount === constants.BULK_EDIT_EMAIL_ACCOUNT_LIMIT && (
        <span className={`${spanClasses} mr-1`}>First</span>
      )}

      <span className={`${spanClasses} mr-2`}>
        {getFormattedTasksCount(selectedTasksCount)}
      </span>

      {!bulkSelectedTasks?.isAllTasksSelected &&
        totalTasks !== selectedTasks?.length && (
          <>
            <span
              role="button"
              className="semibold-1 blue-txt-11"
              {...accessibleOnClick(handleSelectAllTasks)}
            >
              Select all Task(s)
            </span>
            <span className="divider-vertical" />
          </>
        )}

      <span
        role="button"
        className="semibold-1 blue-txt-11"
        {...accessibleOnClick(handleClearSelection)}
      >
        Clear selection
      </span>
    </div>
  );

  if (totalTasks > 0) {
    return (
      <div className={divClasses}>
        {selectedTasks.length > 0 || bulkSelectedTasks?.isAllTasksSelected
          ? renderSelectedTasksDetails()
          : null}
      </div>
    );
  }

  return <></>;
};

export default TasksSelectedRowInfoBanner;
